/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */


/*  This is the common component for showing the info/message including an icon */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';



const template = html` <style include="app-styles">
            .supporting-msg-window-height {
                min-height: var(--supporting-msg-min-height, 35%);
                padding-top: var(--supporting-msg-padding-top, 28px);
                box-sizing: border-box;
            }

            .icon-large {
                width: 72px;
                height: 72px;
            }

            .text-container {
                margin-top: 8px;
            }

            .msg-width-styling {
                @apply --msg-width;
            }
			
			.supporting-msg-content-styling {
              @apply --content-style;
            }
        </style>
        <!-- Painting of Message start -->
        <div class$="supporting-msg-window-height supporting-msg-content-styling {{_getbackgroundColor(background)}}">
            <div class="text-align-center msg-width-styling">

                <!-- Iron icon to be displayed start -->
                <div class="primary-dark-text-m">
                    <iron-icon class="icon-large" id="{{iconName}}" name="{{iconName}}" icon="{{iconName}}"></iron-icon>
                </div>
                <!-- Iron icon to be displayed end -->

                <div class="mdl-grid content-align-center">
                    
                    <!-- Title message to be displayed start -->
                    <div class="mdl-cell mdl-cell--3-col--phone mdl-cell--12-col-desktop mdl-cell--8-col-tablet text-container primary-dark-text-l margin-b-zero">
                        <oe-i18n-msg id="{{titleMsg}}" msgid="{{titleMsg}}"></oe-i18n-msg>
                    </div>
                    <!-- Title message to be displayed end -->

                    <!-- Description message to be displayed start -->
                    <div class="content-align-center mdl-cell mdl-cell--3-col--phone mdl-cell--12-col-desktop mdl-cell--8-col-tablet text-container secondary-dark-text-s mdl-grid mdl-cell--3-col-phone mdl-cell--4-col-desktop mdl-cell--4-col-tablet">
                        <oe-i18n-msg id="{{description}}" msgid="{{description}}"></oe-i18n-msg>
                    </div>
                    <!-- Description message to be displayed end -->

                </div>
            </div>
        </div>
        <!-- Painting of Message end -->`;



Polymer({
    is: 'supporting-msg',
    _template: template,
    properties: {
        /** property used to pass icon id/name */
        iconName: {
            type: String,
            value: ''
        },
        /** property used to pass title message */
        titleMsg: {
            type: String,
            value: ''
        },
        /** property used to pass description message */
        description: {
            type: String,
            value: ''
        },
        /** property used to pass background class for color */
        background: {
            type: String,
            value: ''
        },
        titleplaceholder: {
            type: Array,
            value: [],
            notify: true
        }
    },
    /** function which returns the background class
     * @param {variable} background class
     * @param {return} returns the same class 
     */
    _getbackgroundColor: function (background) {
        return background;
    }
});
